import styled from 'styled-components';
import Box from './Box';
import sp from 'styled-props';

import theme from 'utils/styles/theme';
const sizes = {
	default: theme.grid.gridMaxWidth,
	large: theme.grid.gridMaxWidthLarge
};

const Container = styled(Box)`
	max-width: ${sp(sizes, 'size')};
`;

Container.defaultProps = {
	pb: [6, 5, 7],
	pt: [6, 5, 7],
	px: [3, 3, 3],
	display: 'block',
	fontSize: 'p',
	m: '0 auto',
	width: '100%',
	size: 'default'
};

export default Container;
